import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { defaultOnError } from "util/conditional/onError";
import useUserDateTime from "hooks/useUserDateTime";
import { fetchUsage } from "ai-management/token-usage/api/tokenUsageApi";
import toUsageRequest from "ai-management/token-usage/usageRequest";
const useTokenUsage = (search) => {
  const { userTimezone } = useUserDateTime();
  const request = toUsageRequest(search, userTimezone);
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ai-management", "token-usage", request],
    queryFn: () => defaultOnError(fetchUsage(request), "Loading token usage failed", "Could not load token usage"),
    // Keeps the page from flashing while a new search loads; the search button shows the progress instead.
    placeholderData: keepPreviousData
  });
  return { data, isLoading, isFetching };
};
export default useTokenUsage;
